/**
 * 商品
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2024/6/26      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */

import React from 'react'
import PropTypes from "prop-types";
import dayjs from 'dayjs';
import {symbolMoneyUtil} from '@utils/utils';
import { loadImage } from "@utils/image-func";
import LazyLoad from 'react-lazy-load';
import "./index.less";
const Locale = require("../../../../../../utils/locale").default;
const locale = Locale.current();
const config = require("@config/config");

class Item extends React.Component{
    constructor(props) {
        super(props);
    }

    render(){
        const {item={},currencySymbol=''} = this.props;
        const {goodsSkuVO={}} = item;
        const address = config.essaone[locale];
        return (
            <div className="fuzzy-goods-item__wrap">
                <div className="item">
                    <div className="product-image">
                        {
                            item.discountPercentage?
                                <img className="discount-tag"
                                     src="https://oss.essaone.com/6b0f316c-b85f-4125-8d9f-626d7c44fae7.png"
                                     alt=""/>:
                                null
                        }
                        <LazyLoad height={214}
                                  offset={0}>
                            <img src={loadImage(goodsSkuVO.skuPicUrl,200)} alt=""/>
                        </LazyLoad>
                    </div>
                    <div className="pt_12 pb_12 pl_12 pr_12">
                        <div className="color089 font_18 mb_8 font-weight-bold">{symbolMoneyUtil(goodsSkuVO.salePrice,currencySymbol)}</div>
                        <div className="name cursor-p mb_8" title={goodsSkuVO.name} onClick={(e)=>{
                            e.stopPropagation();
                            e.preventDefault();
                            window.open(`${address}/${goodsSkuVO.goodsId}.html?skuNo=${goodsSkuVO.no}`);
                        }}>{goodsSkuVO.name}</div>
                        <div className="color066 font_14">{item.createTime?dayjs(item.createTime).format('YYYY-MM-DD'):'-'}</div>
                    </div>
                </div>
            </div>
        )
    }
}

Item.defaultProps = {
    item:{},
    //采购商币种符号
    currencySymbol:''
}

Item.propTypes = {

}
export default Item;
